/* eslint-disable react/require-default-props */

import React from 'react';
import {
  Box,
  Button,
  FooterActionBar,
  Icon,
  Tooltip,
} from '@saviynt/design-system';
import cx from 'classnames';
import { useSelector } from 'react-redux';

import { type RootState } from '../../../services/types';
import { useInvertedLocalize } from '../../../utils/localization';

import invertedMessages from './messages';

import './Footer.css';

interface FooterProps {
  onBack?: () => void; // back button callback
  onActivateRule?: () => void;
  isActivating?: boolean;
  isActivateButtonDisabled?: boolean;
  className?: string;
}

/**
 * Footer component containing Back and Save & Activate Rule buttons
 *
 * @param props - The component props
 * @returns JSX element containing the footer
 */
function Footer({
  onBack,
  onActivateRule,
  isActivating = false,
  isActivateButtonDisabled = false,
  className,
}: FooterProps) {
  const l = useInvertedLocalize(invertedMessages);

  // Get menu pinned state from Redux store
  const isMenuPinned = useSelector(
    (state: RootState) => state.user.isMenuPinned
  );

  return (
    <FooterActionBar
      className={cx(
        'Rules-Footer',
        className,
        isMenuPinned && 'Rules-Footer--isMenuPinned'
      )}
      size='large'>
      <Box className='Rules-Footer-backButtonContainer'>
        <Button
          kind='outlined'
          onClick={onBack}
          className='Rules-Footer-backButtonContainer-backButton'>
          {l('Back')}
        </Button>
      </Box>

      <Box className='Rules-Footer-activateButtonContainer'>
        <Tooltip
          text={
            isActivateButtonDisabled
              ? l(
                  "You don't have the permissions to activate or the feature is turned off."
                )
              : ''
          }
          isDisabled={!isActivateButtonDisabled}
          placement='top'>
          <Button
            kind='filled'
            onClick={onActivateRule}
            isLoading={isActivating}
            isDisabled={isActivateButtonDisabled}
            loaderText={l('Activating...')}
            leftIcon={
              <Icon
                kind='QuickAction'
                size='medium'
                color='--color-foreground-neutral-inverse'
              />
            }
            className='Rules-Footer-activateButtonContainer-activateButton'>
            {l('Save & Activate Rule')}
          </Button>
        </Tooltip>
      </Box>
    </FooterActionBar>
  );
}

export default Footer;
